import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-DraftShape",
  "use": "svg-icon-DraftShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-DraftShape\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 14V2H2v12h12zm-1-1V3H3v10h10z\" fill=\"#000\" opacity=\".9\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 7H4v1h8V7zM4 9h8v1H4V9zm0 2h8v1H4v-1z\" fill=\"#000\" opacity=\".9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol